import React, { FC } from 'react';

const IconElectroHome: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 22.3 28"
      {...props}
    >
      <path
        id="Shape_1_"
        className="st0"
        d="M20.9,0H1.3C0.6,0,0,0.6,0,1.4v25.3C0,27.4,0.6,28,1.3,28H21c0.7,0,1.3-0.6,1.3-1.4V1.4
                                	C22.3,0.6,21.7,0,20.9,0z M1.3,0.9H21c0.2,0,0.4,0.2,0.4,0.4v5H0.9v-5C0.9,1.1,1.1,0.9,1.3,0.9z M20.9,27H1.3
                                	c-0.2,0-0.4-0.2-0.4-0.4V7.3h20.4v19.3C21.3,26.8,21.2,27,20.9,27z M11.1,10c-4,0-7.3,3.3-7.3,7.4s3.3,7.4,7.3,7.4s7.3-3.3,7.3-7.4
                                	S15.2,10,11.1,10z M11.1,10.9c3.5,0,6.4,2.8,6.4,6.3c-2.3,1.2-4.2,0.5-6.3-0.3c-2-0.7-4-1.5-6.5-0.5C5.2,13.3,7.9,10.9,11.1,10.9z
                                	 M11.1,23.8c-3.5,0-6.4-2.8-6.4-6.3c2.3-1.2,4.2-0.5,6.3,0.3c1.3,0.5,2.6,1,4.1,1c0.8,0,1.6-0.1,2.5-0.5
                                	C17,21.4,14.3,23.8,11.1,23.8z M4.6,5.6c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2C2.6,4.7,3.5,5.6,4.6,5.6z M4.6,2.5
                                	c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1C4,4.7,3.6,4.2,3.6,3.6C3.6,3,4,2.5,4.6,2.5z M9.5,5.4H18c0.3,0,0.5-0.2,0.5-0.5V2.2
                                	c0-0.3-0.2-0.5-0.5-0.5H9.5C9.2,1.8,9,2,9,2.2v2.7C9,5.2,9.2,5.4,9.5,5.4z M9.9,2.7h7.6v1.7H9.9V2.7z"
      />
    </svg>
  );
};

export default IconElectroHome;
